<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import { Router, Route, navigate } from "svelte-routing";
  import { locale } from "svelte-i18n";

  import { languageInit } from "i18n/language.js";
  import Modal from "components/Modal.svelte";
  import Layout from "./layouts/Main.svelte";

  import Index from "./routes/Index.svelte";
  import Account from "./routes/Account.svelte";
  import Blog from "./routes/blog/Index.svelte";
  import BlogPost from "./routes/blogPost/Index.svelte";
  import Events from "./routes/events/Index.svelte";
  import Workshops from "./routes/workshops/Index.svelte";
  import Registration from "./routes/Registration.svelte";
  import NotFound from "./routes/NotFound.svelte";

  import { authToken, currentLang } from "./stores.js";

  const token = localStorage.getItem("user-token");
  languageInit(window.location.hostname);
  let lang = $locale;
  currentLang.set(lang);

  const onPrivatePages = () => {
    const privatePages = ["/account"];
    const isPrivatePage = privatePages.find(
      (page) => window.location.pathname === page
    );
    return isPrivatePage;
  };

  const appLogin = (token) => {
    localStorage.setItem("user-token", token);
    console.log(token);
    authToken.set(token);
  };

  const appLogout = () => {
    authToken.set(null);
    localStorage.removeItem("user-token");
    if (onPrivatePages()) {
      navigate("/");
    }
  };

  if (token) {
    authToken.set(token);
  } else {
    appLogout();
  }

  onMount(() => {
    // Check token and if valid refresh it
    axios
      .get(`/api/refresh/${token}`)
      .then((response) => {
        const { data } = response;
        if (data && data.token && data.token.length > 0) {
          // store new token
          appLogin(data.token);
        } else {
          appLogout();
        }
      })
      .catch((err) => {
        console.error(err);
        appLogout();
      });
  });
</script>

<Router>
  <Modal>
    <Route path="/blog">
      <Layout>
        <Blog />
      </Layout>
    </Route>
    <Route path="/post/:id" let:params>
      <Layout>
        <BlogPost {...params} />
      </Layout>
    </Route>
    <Route path="/events">
      <Layout>
        <Events {appLogin} {appLogout} />
      </Layout>
    </Route>
    <Route path="/workshops">
      <Layout>
        <Workshops {appLogin} {appLogout} />
      </Layout>
    </Route>
    <Route path="/account">
      <Layout>
        <Account />
      </Layout>
    </Route>
    <Route path="/registration">
      <Layout>
        <Registration {appLogin} />
      </Layout>
    </Route>
    <Route path="/">
      <Layout>
        <Index />
      </Layout>
    </Route>
    <Route path="/*path">
      <NotFound />
    </Route>
  </Modal>
</Router>

<style>
  :global(html) {
    scroll-behavior: smooth;
  }
</style>
